import { axiosApi } from '.';

const formDataConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export interface PreSignedUrlPayload {
  files: {name: string; size: number}[];
}

export const api = {
  savePhysicalExam: (data: FormData) =>
    axiosApi.post('/physical-upload/upload', data, formDataConfig),
  generatePreSignedUrl: (data: PreSignedUrlPayload) =>
    axiosApi.post('/physical-upload/pre-signed', data),
};
